import * as genericUtils from '@tolk-ai/generic-utils';
import * as browserUtils from '@tolk-ai/browser-utils';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$F =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$g = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$f = fails$g;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$f(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$e = fails$g;

var functionBindNative = !fails$e(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$f = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$f.bind(call$f) : function () {
  return call$f.apply(call$f, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var bind$5 = FunctionPrototype$2.bind;
var call$e = FunctionPrototype$2.call;
var uncurryThis$j = NATIVE_BIND$2 && bind$5.bind(call$e, call$e);

var functionUncurryThis = NATIVE_BIND$2 ? function (fn) {
  return fn && uncurryThis$j(fn);
} : function (fn) {
  return fn && function () {
    return call$e.apply(fn, arguments);
  };
};

var uncurryThis$i = functionUncurryThis;

var toString$6 = uncurryThis$i({}.toString);
var stringSlice$4 = uncurryThis$i(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$4(toString$6(it), 8, -1);
};

var global$E = global$F;
var uncurryThis$h = functionUncurryThis;
var fails$d = fails$g;
var classof$6 = classofRaw$1;

var Object$4 = global$E.Object;
var split = uncurryThis$h(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$d(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$6(it) == 'String' ? split(it, '') : Object$4(it);
} : Object$4;

var global$D = global$F;

var TypeError$f = global$D.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$5 = function (it) {
  if (it == undefined) throw TypeError$f("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = indexedObject;
var requireObjectCoercible$4 = requireObjectCoercible$5;

var toIndexedObject$4 = function (it) {
  return IndexedObject(requireObjectCoercible$4(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$j = function (argument) {
  return typeof argument == 'function';
};

var isCallable$i = isCallable$j;

var isObject$7 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$i(it);
};

var global$C = global$F;
var isCallable$h = isCallable$j;

var aFunction = function (argument) {
  return isCallable$h(argument) ? argument : undefined;
};

var getBuiltIn$8 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$C[namespace]) : global$C[namespace] && global$C[namespace][method];
};

var uncurryThis$g = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$g({}.isPrototypeOf);

var getBuiltIn$7 = getBuiltIn$8;

var engineUserAgent = getBuiltIn$7('navigator', 'userAgent') || '';

var global$B = global$F;
var userAgent$3 = engineUserAgent;

var process$3 = global$B.process;
var Deno$1 = global$B.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$c = fails$g;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$c(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$A = global$F;
var getBuiltIn$6 = getBuiltIn$8;
var isCallable$g = isCallable$j;
var isPrototypeOf$2 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var Object$3 = global$A.Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$g($Symbol) && isPrototypeOf$2($Symbol.prototype, Object$3(it));
};

var global$z = global$F;

var String$5 = global$z.String;

var tryToString$4 = function (argument) {
  try {
    return String$5(argument);
  } catch (error) {
    return 'Object';
  }
};

var global$y = global$F;
var isCallable$f = isCallable$j;
var tryToString$3 = tryToString$4;

var TypeError$e = global$y.TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$7 = function (argument) {
  if (isCallable$f(argument)) return argument;
  throw TypeError$e(tryToString$3(argument) + ' is not a function');
};

var aCallable$6 = aCallable$7;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$4 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$6(func);
};

var global$x = global$F;
var call$d = functionCall;
var isCallable$e = isCallable$j;
var isObject$6 = isObject$7;

var TypeError$d = global$x.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$e(fn = input.toString) && !isObject$6(val = call$d(fn, input))) return val;
  if (isCallable$e(fn = input.valueOf) && !isObject$6(val = call$d(fn, input))) return val;
  if (pref !== 'string' && isCallable$e(fn = input.toString) && !isObject$6(val = call$d(fn, input))) return val;
  throw TypeError$d("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var global$w = global$F;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$2 = Object.defineProperty;

var setGlobal$3 = function (key, value) {
  try {
    defineProperty$2(global$w, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$w[key] = value;
  } return value;
};

var global$v = global$F;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$v[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.22.4',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.22.4/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var global$u = global$F;
var requireObjectCoercible$3 = requireObjectCoercible$5;

var Object$2 = global$u.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$2 = function (argument) {
  return Object$2(requireObjectCoercible$3(argument));
};

var uncurryThis$f = functionUncurryThis;
var toObject$1 = toObject$2;

var hasOwnProperty = uncurryThis$f({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$1(it), key);
};

var uncurryThis$e = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$5 = uncurryThis$e(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$5(++id + postfix, 36);
};

var global$t = global$F;
var shared$3 = shared$4.exports;
var hasOwn$8 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$1 = global$t.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$c = function (name) {
  if (!hasOwn$8(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$8(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var global$s = global$F;
var call$c = functionCall;
var isObject$5 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod$3 = getMethod$4;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$b = wellKnownSymbol$c;

var TypeError$c = global$s.TypeError;
var TO_PRIMITIVE = wellKnownSymbol$b('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$5(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$3(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$c(exoticToPrim, input, pref);
    if (!isObject$5(result) || isSymbol$1(result)) return result;
    throw TypeError$c("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$r = global$F;
var isObject$4 = isObject$7;

var document$3 = global$r.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$4(document$3) && isObject$4(document$3.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$7 = descriptors;
var fails$b = fails$g;
var createElement$1 = documentCreateElement$1;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$7 && !fails$b(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$6 = descriptors;
var call$b = functionCall;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$3 = toIndexedObject$4;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$7 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$7(O, P)) return createPropertyDescriptor$1(!call$b(propertyIsEnumerableModule.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$5 = descriptors;
var fails$a = fails$g;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$5 && fails$a(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var global$q = global$F;
var isObject$3 = isObject$7;

var String$4 = global$q.String;
var TypeError$b = global$q.TypeError;

// `Assert: Type(argument) is Object`
var anObject$d = function (argument) {
  if (isObject$3(argument)) return argument;
  throw TypeError$b(String$4(argument) + ' is not an object');
};

var global$p = global$F;
var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$c = anObject$d;
var toPropertyKey = toPropertyKey$2;

var TypeError$a = global$p.TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$4 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$c(O);
  P = toPropertyKey(P);
  anObject$c(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$c(O);
  P = toPropertyKey(P);
  anObject$c(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError$a('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$4 = DESCRIPTORS$3 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$2 = descriptors;
var hasOwn$6 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$6(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || (DESCRIPTORS$2 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$d = functionUncurryThis;
var isCallable$d = isCallable$j;
var store$1 = sharedStore;

var functionToString = uncurryThis$d(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$d(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$4 = store$1.inspectSource;

var global$o = global$F;
var isCallable$c = isCallable$j;
var inspectSource$3 = inspectSource$4;

var WeakMap$1 = global$o.WeakMap;

var nativeWeakMap = isCallable$c(WeakMap$1) && /native code/.test(inspectSource$3(WeakMap$1));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$2 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$n = global$F;
var uncurryThis$c = functionUncurryThis;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var hasOwn$5 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$1 = sharedKey$2;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$9 = global$n.TypeError;
var WeakMap = global$n.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$9('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  var wmget = uncurryThis$c(store.get);
  var wmhas = uncurryThis$c(store.has);
  var wmset = uncurryThis$c(store.set);
  set$1 = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$9(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$5(it, STATE)) throw new TypeError$9(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$5(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$5(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$9 = fails$g;
var isCallable$b = isCallable$j;
var hasOwn$4 = hasOwnProperty_1;
var defineProperty$1 = objectDefineProperty.f;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$4;
var InternalStateModule$1 = internalState;

var enforceInternalState = InternalStateModule$1.enforce;
var getInternalState$1 = InternalStateModule$1.get;

var CONFIGURABLE_LENGTH = !fails$9(function () {
  return defineProperty$1(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$4(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    defineProperty$1(value, 'name', { value: name, configurable: true });
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$4(options, 'arity') && value.length !== options.arity) {
    defineProperty$1(value, 'length', { value: options.arity });
  }
  var state = enforceInternalState(value);
  if (!hasOwn$4(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$b(this) && getInternalState$1(this).source || inspectSource$2(this);
}, 'toString');

var global$m = global$F;
var isCallable$a = isCallable$j;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var makeBuiltIn = makeBuiltIn$2.exports;
var setGlobal$1 = setGlobal$3;

var defineBuiltIn$4 = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  if (isCallable$a(value)) makeBuiltIn(value, name, options);
  if (O === global$m) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return O;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$2(O, key, value);
  return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$4 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor$1 : ceil)(number);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$4;

var max$1 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$3(index);
  return integer < 0 ? max$1(integer + length, 0) : min$2(integer, length);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$4;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  return argument > 0 ? min$1(toIntegerOrInfinity$2(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$1 = toLength$2;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$2 = function (obj) {
  return toLength$1(obj.length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$2;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = lengthOfArrayLike$1(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var uncurryThis$b = functionUncurryThis;
var hasOwn$3 = hasOwnProperty_1;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$1 = uncurryThis$b([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$3(hiddenKeys$2, key) && hasOwn$3(O, key) && push$1(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$3(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$1(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$8;
var uncurryThis$a = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var anObject$b = anObject$d;

var concat$1 = uncurryThis$a([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$b(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$2 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$2(target, key) && !(exceptions && hasOwn$2(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$8 = fails$g;
var isCallable$9 = isCallable$j;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$9(detection) ? fails$8(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$l = global$F;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var defineBuiltIn$3 = defineBuiltIn$4;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced$1 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$l;
  } else if (STATIC) {
    target = global$l[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$l[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$1(sourceProperty, 'sham', true);
    }
    defineBuiltIn$3(target, key, sourceProperty, options);
  }
};

var classof$5 = classofRaw$1;
var global$k = global$F;

var engineIsNode = classof$5(global$k.process) == 'process';

var global$j = global$F;
var isCallable$8 = isCallable$j;

var String$3 = global$j.String;
var TypeError$8 = global$j.TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$8(argument)) return argument;
  throw TypeError$8("Can't set " + String$3(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$9 = functionUncurryThis;
var anObject$a = anObject$d;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$9(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$a(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty = objectDefineProperty.f;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$a = wellKnownSymbol$c;

var TO_STRING_TAG$2 = wellKnownSymbol$a('toStringTag');

var setToStringTag$1 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$1(target, TO_STRING_TAG$2)) {
    defineProperty(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var getBuiltIn$4 = getBuiltIn$8;
var definePropertyModule$1 = objectDefineProperty;
var wellKnownSymbol$9 = wellKnownSymbol$c;
var DESCRIPTORS$1 = descriptors;

var SPECIES$3 = wellKnownSymbol$9('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$4(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule$1.f;

  if (DESCRIPTORS$1 && Constructor && !Constructor[SPECIES$3]) {
    defineProperty(Constructor, SPECIES$3, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var global$i = global$F;
var isPrototypeOf$1 = objectIsPrototypeOf;

var TypeError$7 = global$i.TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$1(Prototype, it)) return it;
  throw TypeError$7('Incorrect invocation');
};

var wellKnownSymbol$8 = wellKnownSymbol$c;

var TO_STRING_TAG$1 = wellKnownSymbol$8('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var global$h = global$F;
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$7 = isCallable$j;
var classofRaw = classofRaw$1;
var wellKnownSymbol$7 = wellKnownSymbol$c;

var TO_STRING_TAG = wellKnownSymbol$7('toStringTag');
var Object$1 = global$h.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$4 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object$1(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$7(O.callee) ? 'Arguments' : result;
};

var uncurryThis$8 = functionUncurryThis;
var fails$7 = fails$g;
var isCallable$6 = isCallable$j;
var classof$3 = classof$4;
var getBuiltIn$3 = getBuiltIn$8;
var inspectSource$1 = inspectSource$4;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$3('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$1 = uncurryThis$8(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$6(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$6(argument)) return false;
  switch (classof$3(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$7(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var global$g = global$F;
var isConstructor = isConstructor$1;
var tryToString$2 = tryToString$4;

var TypeError$6 = global$g.TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError$6(tryToString$2(argument) + ' is not a constructor');
};

var anObject$9 = anObject$d;
var aConstructor = aConstructor$1;
var wellKnownSymbol$6 = wellKnownSymbol$c;

var SPECIES$2 = wellKnownSymbol$6('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$9(O).constructor;
  var S;
  return C === undefined || (S = anObject$9(C)[SPECIES$2]) == undefined ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$2 = FunctionPrototype.apply;
var call$a = FunctionPrototype.call;

// eslint-disable-next-line es-x/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$a.bind(apply$2) : function () {
  return call$a.apply(apply$2, arguments);
});

var uncurryThis$7 = functionUncurryThis;
var aCallable$5 = aCallable$7;
var NATIVE_BIND = functionBindNative;

var bind$4 = uncurryThis$7(uncurryThis$7.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$5(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$4(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var getBuiltIn$2 = getBuiltIn$8;

var html$2 = getBuiltIn$2('document', 'documentElement');

var uncurryThis$6 = functionUncurryThis;

var arraySlice$1 = uncurryThis$6([].slice);

var global$f = global$F;

var TypeError$5 = global$f.TypeError;

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw TypeError$5('Not enough arguments');
  return passed;
};

var userAgent$2 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var global$e = global$F;
var apply$1 = functionApply;
var bind$3 = functionBindContext;
var isCallable$5 = isCallable$j;
var hasOwn = hasOwnProperty_1;
var fails$6 = fails$g;
var html$1 = html$2;
var arraySlice = arraySlice$1;
var createElement = documentCreateElement$1;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$2 = engineIsNode;

var set = global$e.setImmediate;
var clear = global$e.clearImmediate;
var process$2 = global$e.process;
var Dispatch = global$e.Dispatch;
var Function$1 = global$e.Function;
var MessageChannel = global$e.MessageChannel;
var String$2 = global$e.String;
var counter = 0;
var queue$1 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global$e.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn(queue$1, id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$e.postMessage(String$2(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$5(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue$1[++counter] = function () {
      apply$1(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (IS_NODE$2) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$3(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$e.addEventListener &&
    isCallable$5(global$e.postMessage) &&
    !global$e.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails$6(post)
  ) {
    defer = post;
    global$e.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html$1.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html$1.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var userAgent$1 = engineUserAgent;
var global$d = global$F;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && global$d.Pebble !== undefined;

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$c = global$F;
var bind$2 = functionBindContext;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$1 = engineIsNode;

var MutationObserver = global$c.MutationObserver || global$c.WebKitMutationObserver;
var document$2 = global$c.document;
var process$1 = global$c.process;
var Promise$1 = global$c.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$c, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$1 && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$1 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$2(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$1) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind$2(macrotask, global$c);
    notify$1 = function () {
      macrotask(flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var global$b = global$F;

var hostReportErrors$1 = function (a, b) {
  var console = global$b.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var Queue$1 = function () {
  this.head = null;
  this.tail = null;
};

Queue$1.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

var queue = Queue$1;

var global$a = global$F;

var promiseNativeConstructor = global$a.Promise;

var engineIsBrowser = typeof window == 'object' && typeof Deno != 'object';

var global$9 = global$F;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$4 = isCallable$j;
var isForced = isForced_1;
var inspectSource = inspectSource$4;
var wellKnownSymbol$5 = wellKnownSymbol$c;
var IS_BROWSER = engineIsBrowser;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES$1 = wellKnownSymbol$5('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$4(global$9.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES$1] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$4 = aCallable$7;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$4(resolve);
  this.reject = aCallable$4(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$7 = _export;
var IS_NODE = engineIsNode;
var global$8 = global$F;
var call$9 = functionCall;
var defineBuiltIn$2 = defineBuiltIn$4;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$1;
var setSpecies = setSpecies$1;
var aCallable$3 = aCallable$7;
var isCallable$3 = isCallable$j;
var isObject$1 = isObject$7;
var anInstance = anInstance$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask$1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue;
var InternalStateModule = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$4 = global$8.TypeError;
var document$1 = global$8.document;
var process = global$8.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$8.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$1(it) && isCallable$3(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$4('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$9(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$8.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$8['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$9(task, global$8, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$9(task, global$8, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$4("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$9(then, value,
            bind$1(internalResolve, wrapper, state),
            bind$1(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable$3(executor);
    call$9(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$2(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$3(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$3(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$3(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$2(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$9(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$7({ global: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var iterators = {};

var wellKnownSymbol$4 = wellKnownSymbol$c;
var Iterators$1 = iterators;

var ITERATOR$2 = wellKnownSymbol$4('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$2] === it);
};

var classof$2 = classof$4;
var getMethod$2 = getMethod$4;
var Iterators = iterators;
var wellKnownSymbol$3 = wellKnownSymbol$c;

var ITERATOR$1 = wellKnownSymbol$3('iterator');

var getIteratorMethod$2 = function (it) {
  if (it != undefined) return getMethod$2(it, ITERATOR$1)
    || getMethod$2(it, '@@iterator')
    || Iterators[classof$2(it)];
};

var global$7 = global$F;
var call$8 = functionCall;
var aCallable$2 = aCallable$7;
var anObject$8 = anObject$d;
var tryToString$1 = tryToString$4;
var getIteratorMethod$1 = getIteratorMethod$2;

var TypeError$3 = global$7.TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$2(iteratorMethod)) return anObject$8(call$8(iteratorMethod, argument));
  throw TypeError$3(tryToString$1(argument) + ' is not iterable');
};

var call$7 = functionCall;
var anObject$7 = anObject$d;
var getMethod$1 = getMethod$4;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$7(iterator);
  try {
    innerResult = getMethod$1(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$7(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$7(innerResult);
  return value;
};

var global$6 = global$F;
var bind = functionBindContext;
var call$6 = functionCall;
var anObject$6 = anObject$d;
var tryToString = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike = lengthOfArrayLike$2;
var isPrototypeOf = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose = iteratorClose$1;

var TypeError$2 = global$6.TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$2 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$6(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError$2(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call$6(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$2 = wellKnownSymbol$c;

var ITERATOR = wellKnownSymbol$2('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$6 = _export;
var call$5 = functionCall;
var aCallable$1 = aCallable$7;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$1 = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$6({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$5($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$5 = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$8;
var isCallable$2 = isCallable$j;
var defineBuiltIn$1 = defineBuiltIn$4;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$5({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$2(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn$1(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$4 = _export;
var call$4 = functionCall;
var aCallable = aCallable$7;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$4({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call$4($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$3 = _export;
var call$3 = functionCall;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$3({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call$3(capability.reject, undefined, r);
    return capability.promise;
  }
});

var anObject$5 = anObject$d;
var isObject = isObject$7;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$5(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$2 = _export;
var getBuiltIn = getBuiltIn$8;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$2({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

var GetOneShopInfosErrors;

(function (GetOneShopInfosErrors) {
  GetOneShopInfosErrors[GetOneShopInfosErrors["inexistingShopInfos"] = 0] = "inexistingShopInfos";
})(GetOneShopInfosErrors || (GetOneShopInfosErrors = {}));

var AuthenticateWithShopifyLoginErrors;

(function (AuthenticateWithShopifyLoginErrors) {
  AuthenticateWithShopifyLoginErrors[AuthenticateWithShopifyLoginErrors["invalidState"] = 0] = "invalidState";
  AuthenticateWithShopifyLoginErrors[AuthenticateWithShopifyLoginErrors["appAlreadyInstalled"] = 1] = "appAlreadyInstalled";
  AuthenticateWithShopifyLoginErrors[AuthenticateWithShopifyLoginErrors["userAccessDenied"] = 2] = "userAccessDenied";
  AuthenticateWithShopifyLoginErrors[AuthenticateWithShopifyLoginErrors["inexistingAccessToken"] = 3] = "inexistingAccessToken";
  AuthenticateWithShopifyLoginErrors[AuthenticateWithShopifyLoginErrors["inexistingShopOwner"] = 4] = "inexistingShopOwner";
})(AuthenticateWithShopifyLoginErrors || (AuthenticateWithShopifyLoginErrors = {}));

var UpdateOneShopInfosErrors;

(function (UpdateOneShopInfosErrors) {
  UpdateOneShopInfosErrors[UpdateOneShopInfosErrors["inexistingShopInfos"] = 0] = "inexistingShopInfos";
})(UpdateOneShopInfosErrors || (UpdateOneShopInfosErrors = {}));

var DisconnectOneShopInfosErrors;

(function (DisconnectOneShopInfosErrors) {
  DisconnectOneShopInfosErrors[DisconnectOneShopInfosErrors["inexistingShopInfos"] = 0] = "inexistingShopInfos";
})(DisconnectOneShopInfosErrors || (DisconnectOneShopInfosErrors = {}));

var applicationPorts = /*#__PURE__*/Object.freeze({
	__proto__: null,
	get AuthenticateWithShopifyLoginErrors () { return AuthenticateWithShopifyLoginErrors; },
	get DisconnectOneShopInfosErrors () { return DisconnectOneShopInfosErrors; },
	get GetOneShopInfosErrors () { return GetOneShopInfosErrors; },
	get UpdateOneShopInfosErrors () { return UpdateOneShopInfosErrors; }
});

const getOneShopInfosById$1 = axios => async shopInfosId => {
  try {
    return (await axios.get(`/v1/shopify-shop-infos/${shopInfosId}`)).data;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingShopInfos':
          return GetOneShopInfosErrors.inexistingShopInfos;

        default:
          throw genericUtils.sanitizeError(error);
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const getOneShopInfosByBotId$3 = axios => async botId => {
  try {
    return (await axios.get(`/v1/bots/${botId}/shop-infos`)).data;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      switch (error.response.data.error) {
        case 'inexistingShopInfos':
          return GetOneShopInfosErrors.inexistingShopInfos;

        default:
          throw genericUtils.sanitizeError(error);
      }
    }

    throw genericUtils.sanitizeError(error);
  }
};

const createOneShopifyLoginConfig$2 = axios => async (shopUrl, state) => {
  try {
    return (await axios.post(`/v1/shopify-login-config?shop=${shopUrl}&state=${state}`)).data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertRestShopInfosToShopInfos = restShopInfos => ({
  accessToken: restShopInfos.accessToken,
  botId: restShopInfos.botId,
  clientId: restShopInfos.clientId,
  email: restShopInfos.email,
  id: restShopInfos.id,
  phoneNumber: restShopInfos.phoneNumber,
  scriptShopifyId: restShopInfos.scriptShopifyId,
  shopName: restShopInfos.shopName,
  shopOwner: restShopInfos.shopOwner,
  webhookId: restShopInfos.webhookId,
  websiteUrl: restShopInfos.websiteUrl
});

const getOneShopInfos$1 = axios => async shopInfosId => {
  const result = await getOneShopInfosById$1(axios)(shopInfosId);

  if (genericUtils.isDomainError(result, GetOneShopInfosErrors)) {
    return result;
  }

  return convertRestShopInfosToShopInfos(result);
};

const createOneShopifyLoginConfig$1 = axios => async (shopUrl, state) => {
  const result = await createOneShopifyLoginConfig$2(axios)(shopUrl, state);
  return result;
};

const getOneShopInfosByBotId$2 = axios => async botId => {
  const result = await getOneShopInfosByBotId$3(axios)(botId);

  if (genericUtils.isDomainError(result, GetOneShopInfosErrors)) {
    return result;
  }

  return convertRestShopInfosToShopInfos(result);
};

var index$8 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	createOneShopifyLoginConfig: createOneShopifyLoginConfig$1,
	getOneShopInfos: getOneShopInfos$1,
	getOneShopInfosByBotId: getOneShopInfosByBotId$2
});

const removeOneShopifyActionByBotId$1 = (axios, actionId) => async botId => {
  try {
    await axios.delete(`/v1/bots/${botId}/actions/${actionId}/config`);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const removeOneShopifyActionByBotId = (axios, actionId) => async botId => {
  await removeOneShopifyActionByBotId$1(axios, actionId)(botId);
};

var index$7 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	removeOneShopifyActionByBotId: removeOneShopifyActionByBotId
});

var global$5 = global$F;
var classof$1 = classof$4;

var String$1 = global$5.String;

var toString$4 = function (argument) {
  if (classof$1(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String$1(argument);
};

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$5 = functionUncurryThis;
var requireObjectCoercible$2 = requireObjectCoercible$5;
var toString$3 = toString$4;
var whitespaces$1 = whitespaces$2;

var replace$2 = uncurryThis$5(''.replace);
var whitespace = '[' + whitespaces$1 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = toString$3(requireObjectCoercible$2($this));
    if (TYPE & 1) string = replace$2(string, ltrim, '');
    if (TYPE & 2) string = replace$2(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$1(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails$5 = fails$g;
var whitespaces = whitespaces$2;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$5(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$1 = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$1({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

const getOnePgShopInfosById = pool => async shopInfosId => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT shop_info_id,
            access_token,
            "shop_info".email,
            "shop_info".website_url,
            user_name,
            shop_name,
            "client".client_id,
            bot_id,
            script_shopify_id,
            webhook_id,
            "shop_info".phone_number
            FROM "shop_info"
            LEFT JOIN "client" on "client".id = "shop_info".client_id
            WHERE shop_info_id = $1;`, [shopInfosId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePgShopInfosByBotId = pool => async botId => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT shop_info_id,
              access_token,
              "shop_info".email,
              "shop_info".website_url,
              user_name,
              shop_name,
              client.client_id,
              bot_id,
              script_shopify_id,
              webhook_id,
              "shop_info".phone_number
            FROM "shop_info"
            LEFT JOIN client on client.id = shop_info.client_id
            WHERE bot_id = $1;`, [botId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const saveOnePgShopInfos = pool => async shopInfos => {
  await pool.query(`INSERT INTO
      "shop_info" (
        shop_info_id,
        access_token,
        email,
        website_url,
        shop_name,
        user_name,
        client_id,
        bot_id,
        script_shopify_id,
        webhook_id,
        phone_number)
        VALUES($1, $2, $3, $4, $5, $6, (SELECT "client".id FROM "client" WHERE "client".client_id = $7), $8, $9, $10, $11)
        ON CONFLICT (shop_info_id) DO UPDATE SET
        shop_info_id=$1,
        access_token=$2,
        email=$3,
        website_url=$4,
        shop_name=$5,
        user_name=$6,
        client_id=(SELECT "client".id FROM "client" WHERE "client".client_id = $7),
        bot_id=$8,
        script_shopify_id=$9,
        webhook_id=$10,
        phone_number=$11 ;`, [shopInfos.id, shopInfos.accessToken, shopInfos.email, shopInfos.websiteUrl, shopInfos.shopName, shopInfos.shopOwner, shopInfos.clientId, shopInfos.botId, shopInfos.scriptShopifyId, shopInfos.webhookId, shopInfos.phoneNumber]);
};

const updateOnePgShopInfos = pool => async shopInfos => {
  await pool.query(`UPDATE "shop_info"
      SET
        access_token=$1,
        email=$2,
        website_url=$3,
        shop_name=$4,
        user_name=$5,
        client_id = (SELECT "client".id FROM "client" WHERE "client".client_id = $6),
        bot_id=$7,
        script_shopify_id=$8,
        webhook_id=$9,
        phone_number=$10
      WHERE shop_info_id=$11;
    `, [shopInfos.accessToken, shopInfos.email, shopInfos.websiteUrl, shopInfos.shopName, shopInfos.shopOwner, shopInfos.clientId, shopInfos.botId, shopInfos.scriptShopifyId, shopInfos.webhookId, shopInfos.phoneNumber, shopInfos.id]);
};

const getWebhooksShopify = axios => async (shopInfosId, shopInfosAccessToken) => {
  try {
    const restWebhooksShopify = await axios.get(`https://${shopInfosId}.myshopify.com/admin/api/2021-10/webhooks.json`, {
      headers: {
        'X-Shopify-Access-Token': shopInfosAccessToken
      }
    });
    return restWebhooksShopify.data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const registerUninstallWebhook$1 = (axios, webhookBaseUrl) => async (shopInfosId, shopInfosAccessToken) => {
  try {
    const restShopifyWebhook = await axios.post(`https://${shopInfosId}.myshopify.com/admin/api/2021-10/webhooks.json`, {
      webhook: {
        address: `${webhookBaseUrl}/v1/webhooks/shopify/app-uninstall`,
        fields: ['id', 'domain'],
        format: 'json',
        topic: 'app/uninstalled'
      }
    }, {
      headers: {
        'X-Shopify-Access-Token': shopInfosAccessToken
      }
    });
    return restShopifyWebhook.data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const removeShopifyWebhook = axios => async (shopifyWebhookId, shopInfosId, shopInfosAccessToken) => {
  try {
    await axios.delete(`https://${shopInfosId}.myshopify.com/admin/api/2021-10/webhooks/${shopifyWebhookId}.json`, {
      headers: {
        'X-Shopify-Access-Token': shopInfosAccessToken
      }
    });
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const hasUninstallWebhook = (webhookBaseUrl, restShopifyWebhooks) => {
  const shopifyWebhook = restShopifyWebhooks.webhooks.find(shopifyWebhook => shopifyWebhook.topic === 'app/uninstalled' && shopifyWebhook.address === `${webhookBaseUrl}/v1/webhooks/shopify/app-uninstall`);

  if (typeof shopifyWebhook === 'undefined') {
    return null;
  }

  return shopifyWebhook;
};

const removeOnePgShopInfosById = pool => async shopInfosId => {
  await pool.query(`DELETE FROM shop_info
     WHERE shop_info_id=$1
`, [shopInfosId]);
};

const getOnePgShopInfosByUserId = pool => async userId => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT shop_info_id,
            access_token,
            "shop_info".email,
            "shop_info".website_url,
            user_name,
            shop_name,
            "client".client_id,
            bot_id,
            script_shopify_id,
            webhook_id,
            "shop_info".phone_number
            FROM "shop_info"
            INNER JOIN "client" on "client".id = "shop_info".client_id
            INNER JOIN "client_user" on "client_user".client_id = "client".id
            WHERE "client_user".user_id = $1;`, [userId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertPgShopInfosToShopInfos = pgShopInfos => ({
  accessToken: pgShopInfos.access_token,
  botId: pgShopInfos.bot_id,
  clientId: pgShopInfos.client_id,
  email: pgShopInfos.email,
  id: pgShopInfos.shop_info_id,
  phoneNumber: pgShopInfos.phone_number,
  scriptShopifyId: pgShopInfos.script_shopify_id,
  shopName: pgShopInfos.shop_name.trim(),
  shopOwner: pgShopInfos.user_name.trim(),
  webhookId: pgShopInfos.webhook_id,
  websiteUrl: pgShopInfos.website_url
});

const convertRestShopifyWebhookToShopifyWebhook = restShopifyWebhook => ({
  id: restShopifyWebhook.webhook.id
});

const getOneShopInfosById = pool => async shopInfosId => {
  const shopInfos = await getOnePgShopInfosById(pool)(shopInfosId);
  return shopInfos === null ? null : convertPgShopInfosToShopInfos(shopInfos);
};

const getOneShopInfosByBotId$1 = pool => async botId => {
  const shopInfos = await getOnePgShopInfosByBotId(pool)(botId);
  return shopInfos === null ? null : convertPgShopInfosToShopInfos(shopInfos);
};

const saveOneShopInfos = pool => async shopInfos => {
  await saveOnePgShopInfos(pool)(shopInfos);
};

const updateOneShopInfos$1 = pool => async shopInfos => {
  await updateOnePgShopInfos(pool)(shopInfos);
};

const registerUninstallWebhook = (axios, webhookBaseUrl) => async (shopInfosId, shopInfosAccessToken) => {
  const restWebhooksShopify = await getWebhooksShopify(axios)(shopInfosId, shopInfosAccessToken);
  const uninstallWebhook = hasUninstallWebhook(webhookBaseUrl, restWebhooksShopify);

  if (uninstallWebhook !== null) {
    await removeShopifyWebhook(axios)(uninstallWebhook.id, shopInfosId, shopInfosAccessToken);
  }

  const restShopifyWebhook = await registerUninstallWebhook$1(axios, webhookBaseUrl)(shopInfosId, shopInfosAccessToken);
  return convertRestShopifyWebhookToShopifyWebhook(restShopifyWebhook);
};

const removeOneShopInfosById = pool => async shopInfosId => {
  await removeOnePgShopInfosById(pool)(shopInfosId);
};

const getOneShopInfosByUserId$1 = pool => async userId => {
  const shopInfos = await getOnePgShopInfosByUserId(pool)(userId);
  return shopInfos === null ? null : convertPgShopInfosToShopInfos(shopInfos);
};

var index$6 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getOneShopInfosByBotId: getOneShopInfosByBotId$1,
	getOneShopInfosById: getOneShopInfosById,
	getOneShopInfosByUserId: getOneShopInfosByUserId$1,
	registerUninstallWebhook: registerUninstallWebhook,
	removeOneShopInfosById: removeOneShopInfosById,
	saveOneShopInfos: saveOneShopInfos,
	updateOneShopInfos: updateOneShopInfos$1
});

const getOneShopOwnerInfos$1 = axios => async (accessToken, shopDomain) => {
  try {
    const restShopOwnerInfos = await axios.get(`https://${shopDomain}.myshopify.com/admin/api/2021-07/shop.json`, {
      headers: {
        'X-Shopify-Access-Token': accessToken
      }
    });
    return genericUtils.isObject(restShopOwnerInfos.data) ? restShopOwnerInfos.data : null;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.status === genericUtils.HTTP_CODE.NOT_FOUND) {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertRestShopOwnerInfosToShopOwnerinfos = restShopOwnerInfos => ({
  email: restShopOwnerInfos.shop.email,
  phoneNumber: restShopOwnerInfos.shop.phone !== null && genericUtils.isValidPhoneNumber(restShopOwnerInfos.shop.phone) ? restShopOwnerInfos.shop.phone : null,
  shopName: restShopOwnerInfos.shop.name,
  shopOwner: restShopOwnerInfos.shop.shop_owner,
  websiteUrl: restShopOwnerInfos.shop.domain
});

const getOneShopOwnerInfos = axios => async (accessToken, shopDomain) => {
  const shopInfos = await getOneShopOwnerInfos$1(axios)(accessToken, shopDomain);
  return shopInfos === null ? null : convertRestShopOwnerInfosToShopOwnerinfos(shopInfos);
};

var index$5 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getOneShopOwnerInfos: getOneShopOwnerInfos
});

const getOneRestShopifyLoginAccessToken = axios => async (shopifyAccessTokenUrl, shopifyRequestAccessToken) => {
  try {
    return (await axios.post(shopifyAccessTokenUrl, shopifyRequestAccessToken)).data;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.status >= genericUtils.HTTP_CODE.BAD_REQUEST && error.response.status < genericUtils.HTTP_CODE.INTERNAL_ERROR) {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const getOneShopifyLoginAccessToken = (axios, shopifyClientId, shopifyClientSecret) => async (shopifyLoginConfig, authorizationCode) => {
  const shopifyAccessTokenUrl = `https://${shopifyLoginConfig.subDomain}.myshopify.com/admin/oauth/access_token`;
  const shopifyRequestAccessToken = {
    client_id: shopifyClientId,
    client_secret: shopifyClientSecret,
    code: authorizationCode
  };
  const shopifyAccessToken = await getOneRestShopifyLoginAccessToken(axios)(shopifyAccessTokenUrl, shopifyRequestAccessToken);

  if (!shopifyAccessToken) {
    return null;
  }

  return shopifyAccessToken.access_token;
};

var index$4 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getOneShopifyLoginAccessToken: getOneShopifyLoginAccessToken
});

const insertOneShopifyLoginConfigPg = pool => async shopifyLoginConfig => {
  await pool.query(`INSERT INTO
      "shopify_login_config" (
        access_token,
        sub_domain,
        login_url,
        state
       )
        VALUES($1, $2, $3, $4);`, [shopifyLoginConfig.accessToken, shopifyLoginConfig.subDomain, shopifyLoginConfig.loginUrl, shopifyLoginConfig.state]);
};

const getOneShopifyLoginConfigByState$1 = pool => async state => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT access_token,
            sub_domain,
            login_url,
            state
            FROM "shopify_login_config"
            WHERE state = $1;`, [state])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const deleteAllPgShopifyLoginConfigByShopName = pool => async shopName => {
  await pool.query(`DELETE FROM shopify_login_config
    WHERE sub_domain=$1
    `, [shopName]);
};

const convertPgShopifyLoginConfigToShopifyLoginConfig = pgShopifyLoginConfig => ({
  accessToken: pgShopifyLoginConfig.access_token,
  loginUrl: pgShopifyLoginConfig.login_url,
  state: pgShopifyLoginConfig.state,
  subDomain: pgShopifyLoginConfig.sub_domain
});

const insertOneShopifyLoginConfig = pool => async shopifyLoginConfig => {
  await insertOneShopifyLoginConfigPg(pool)(shopifyLoginConfig);
};

const getOneShopifyLoginConfigByState = pool => async state => {
  const shopifyLoginConfig = await getOneShopifyLoginConfigByState$1(pool)(state);
  return shopifyLoginConfig === null ? null : convertPgShopifyLoginConfigToShopifyLoginConfig(shopifyLoginConfig);
};

const deleteAllShopifyLoginConfigByShopName = pool => async shopName => {
  await deleteAllPgShopifyLoginConfigByShopName(pool)(shopName);
};

var index$3 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	deleteAllShopifyLoginConfigByShopName: deleteAllShopifyLoginConfigByShopName,
	getOneShopifyLoginConfigByState: getOneShopifyLoginConfigByState,
	insertOneShopifyLoginConfig: insertOneShopifyLoginConfig
});

var $schema = "http://json-schema.org/draft-07/schema#";
var definitions = {
	RestShopifyLoginUrl: {
		type: "string"
	},
	RestShopInfosId: {
		type: "string"
	},
	RestShopInfos: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/RestShopInfosId"
			},
			accessToken: {
				type: "string"
			},
			email: {
				type: "string"
			},
			websiteUrl: {
				type: "string"
			},
			shopName: {
				type: "string"
			},
			shopOwner: {
				type: "string"
			},
			clientId: {
				type: [
					"string",
					"null"
				]
			},
			botId: {
				type: [
					"string",
					"null"
				]
			},
			scriptShopifyId: {
				type: [
					"string",
					"null"
				]
			},
			webhookId: {
				type: [
					"string",
					"null"
				]
			},
			phoneNumber: {
				type: [
					"string",
					"null"
				]
			}
		},
		required: [
			"id",
			"accessToken",
			"email",
			"websiteUrl",
			"shopName",
			"shopOwner",
			"clientId",
			"botId",
			"scriptShopifyId",
			"webhookId",
			"phoneNumber"
		],
		additionalProperties: false
	},
	ClientId: {
		type: "string"
	},
	Client: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/ClientId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	ShopInfosId: {
		type: "string"
	},
	ShopInfosUrl: {
		type: "string"
	},
	ShopInfosAccessToken: {
		type: "string"
	},
	ShopInfosShopName: {
		type: "string"
	},
	ShopInfosShopOwner: {
		type: "string"
	},
	ShopInfosEmail: {
		type: "string"
	},
	ShopInfosPhoneNumber: {
		type: "string"
	},
	ShopifyLoginUrl: {
		type: "string"
	},
	ShopUrl: {
		type: "string"
	},
	BotId: {
		type: "string"
	},
	ScriptShopifyId: {
		type: "string"
	},
	ShopInfosWebhookId: {
		type: [
			"string",
			"null"
		]
	},
	ShopInfos: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/ShopInfosId"
			},
			accessToken: {
				$ref: "#/definitions/ShopInfosAccessToken"
			},
			email: {
				$ref: "#/definitions/ShopInfosEmail"
			},
			websiteUrl: {
				type: "string"
			},
			shopName: {
				$ref: "#/definitions/ShopInfosShopName"
			},
			shopOwner: {
				$ref: "#/definitions/ShopInfosShopOwner"
			},
			clientId: {
				type: [
					"string",
					"null"
				]
			},
			botId: {
				anyOf: [
					{
						$ref: "#/definitions/BotId"
					},
					{
						type: "null"
					}
				]
			},
			scriptShopifyId: {
				anyOf: [
					{
						$ref: "#/definitions/ScriptShopifyId"
					},
					{
						type: "null"
					}
				]
			},
			webhookId: {
				$ref: "#/definitions/ShopInfosWebhookId"
			},
			phoneNumber: {
				anyOf: [
					{
						type: "null"
					},
					{
						$ref: "#/definitions/ShopInfosPhoneNumber"
					}
				]
			}
		},
		required: [
			"id",
			"accessToken",
			"email",
			"websiteUrl",
			"shopName",
			"shopOwner",
			"clientId",
			"botId",
			"scriptShopifyId",
			"webhookId",
			"phoneNumber"
		],
		additionalProperties: false
	},
	ShopOwnerInfos: {
		type: "object",
		properties: {
			email: {
				type: "string"
			},
			websiteUrl: {
				type: "string"
			},
			shopName: {
				type: "string"
			},
			shopOwner: {
				type: "string"
			},
			phoneNumber: {
				type: [
					"null",
					"string"
				]
			}
		},
		required: [
			"email",
			"websiteUrl",
			"shopName",
			"shopOwner",
			"phoneNumber"
		],
		additionalProperties: false
	},
	ShopifyWebhook: {
		type: "object",
		properties: {
			id: {
				type: "string"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	ScriptShopify: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/ScriptShopifyId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	ShopifyLoginState: {
		type: "string"
	},
	ShopifyLoginAuthorizationCode: {
		type: "string"
	},
	ShopifyLoginAccessToken: {
		type: "string"
	},
	ShopifyLoginSubdomain: {
		type: "string"
	},
	ShopifyLoginBotId: {
		type: "string"
	},
	ShopifyLoginConfig: {
		type: "object",
		properties: {
			loginUrl: {
				type: "string"
			},
			subDomain: {
				$ref: "#/definitions/ShopifyLoginSubdomain"
			},
			state: {
				$ref: "#/definitions/ShopifyLoginState"
			},
			accessToken: {
				anyOf: [
					{
						$ref: "#/definitions/ShopifyLoginAccessToken"
					},
					{
						type: "null"
					}
				]
			}
		},
		required: [
			"loginUrl",
			"subDomain",
			"state",
			"accessToken"
		],
		additionalProperties: false
	},
	UserId: {
		type: "string"
	},
	User: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/UserId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	PgShopInfos: {
		type: "object",
		properties: {
			shop_info_id: {
				type: "string"
			},
			access_token: {
				type: "string"
			},
			email: {
				type: "string"
			},
			website_url: {
				type: "string"
			},
			shop_name: {
				type: "string"
			},
			user_name: {
				type: "string"
			},
			client_id: {
				type: [
					"string",
					"null"
				]
			},
			bot_id: {
				type: [
					"string",
					"null"
				]
			},
			script_shopify_id: {
				type: [
					"string",
					"null"
				]
			},
			webhook_id: {
				type: [
					"string",
					"null"
				]
			},
			phone_number: {
				type: [
					"string",
					"null"
				]
			}
		},
		required: [
			"shop_info_id",
			"access_token",
			"email",
			"website_url",
			"shop_name",
			"user_name",
			"client_id",
			"bot_id",
			"script_shopify_id",
			"webhook_id",
			"phone_number"
		],
		additionalProperties: false
	},
	ShopifyWebhookId: {
		type: "string"
	},
	RestShopifyWebhookInfo: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/ShopifyWebhookId"
			},
			address: {
				type: "string"
			},
			topic: {
				type: "string"
			}
		},
		required: [
			"id",
			"address",
			"topic"
		],
		additionalProperties: false
	},
	RestShopifyWebhook: {
		type: "object",
		properties: {
			webhook: {
				$ref: "#/definitions/RestShopifyWebhookInfo"
			}
		},
		required: [
			"webhook"
		],
		additionalProperties: false
	},
	RestShopifyWebhooks: {
		type: "object",
		properties: {
			webhooks: {
				type: "array",
				items: {
					$ref: "#/definitions/RestShopifyWebhookInfo"
				}
			}
		},
		required: [
			"webhooks"
		],
		additionalProperties: false
	},
	RestShop: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			email: {
				type: "string"
			},
			domain: {
				type: "string"
			},
			shop_owner: {
				type: "string"
			},
			phone: {
				type: [
					"null",
					"string"
				]
			}
		},
		required: [
			"name",
			"email",
			"domain",
			"shop_owner",
			"phone"
		],
		additionalProperties: false
	},
	RestShopOwnerInfos: {
		type: "object",
		properties: {
			shop: {
				$ref: "#/definitions/RestShop"
			}
		},
		required: [
			"shop"
		],
		additionalProperties: false
	},
	RestShopifyRequestAccessToken: {
		type: "object",
		properties: {
			client_id: {
				type: "string"
			},
			client_secret: {
				type: "string"
			},
			code: {
				type: "string"
			}
		},
		required: [
			"client_id",
			"client_secret",
			"code"
		],
		additionalProperties: false
	},
	RestShopifyLoginAccessToken: {
		type: "object",
		properties: {
			access_token: {
				type: "string"
			},
			scope: {
				type: "string"
			}
		},
		required: [
			"access_token",
			"scope"
		],
		additionalProperties: false
	},
	PgShopifyLoginConfig: {
		type: "object",
		properties: {
			access_token: {
				type: "string"
			},
			sub_domain: {
				type: "string"
			},
			login_url: {
				type: "string"
			},
			state: {
				type: "string"
			}
		},
		required: [
			"access_token",
			"sub_domain",
			"login_url",
			"state"
		],
		additionalProperties: false
	}
};
var entitiesSchemas = {
	$schema: $schema,
	definitions: definitions
};

var entitiesSchemas$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	$schema: $schema,
	definitions: definitions,
	'default': entitiesSchemas
});

const shopInfosFactory = () => (accessToken, websiteUrl, email, shopName, shopOwner, webhookId, phoneNumber, id, clientId, botId, scriptShopifyId // eslint-disable-next-line max-params
) => ({
  accessToken,
  botId: botId !== null && botId !== void 0 ? botId : null,
  clientId: clientId !== null && clientId !== void 0 ? clientId : null,
  email: email.toLowerCase(),
  id: id !== null && id !== void 0 ? id : genericUtils.generateUniqueId(),
  phoneNumber,
  scriptShopifyId: scriptShopifyId !== null && scriptShopifyId !== void 0 ? scriptShopifyId : null,
  shopName,
  shopOwner,
  webhookId: webhookId !== null && webhookId !== void 0 ? webhookId : null,
  websiteUrl
});

var index$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	shopInfosFactory: shopInfosFactory
});

var anObject$4 = anObject$d;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$4(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var fails$4 = fails$g;
var global$4 = global$F;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$4.RegExp;

var UNSUPPORTED_Y$1 = fails$4(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$4(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$4(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$3 = anObject$d;
var toIndexedObject = toIndexedObject$4;
var objectKeys = objectKeys$1;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$3(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

/* global ActiveXObject -- old IE, WSH */

var anObject$2 = anObject$d;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$2;
var documentCreateElement = documentCreateElement$1;
var sharedKey = sharedKey$2;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$2(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var fails$3 = fails$g;
var global$3 = global$F;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$3.RegExp;

var regexpUnsupportedDotAll = fails$3(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$2 = fails$g;
var global$2 = global$F;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$2.RegExp;

var regexpUnsupportedNcg = fails$2(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$2 = functionCall;
var uncurryThis$4 = functionUncurryThis;
var toString$2 = toString$4;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4.exports;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$4(''.charAt);
var indexOf = uncurryThis$4(''.indexOf);
var replace$1 = uncurryThis$4(''.replace);
var stringSlice$3 = uncurryThis$4(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$2(nativeExec, re1, 'a');
  call$2(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$2(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$2(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$2(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$1(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$3(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$2(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$3(match.input, charsAdded);
        match[0] = stringSlice$3(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      call$2(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $ = _export;
var exec = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$3 = functionUncurryThis;
var defineBuiltIn = defineBuiltIn$4;
var regexpExec$1 = regexpExec$2;
var fails$1 = fails$g;
var wellKnownSymbol$1 = wellKnownSymbol$c;
var createNonEnumerableProperty = createNonEnumerableProperty$4;

var SPECIES = wellKnownSymbol$1('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$1(KEY);

  var DELEGATES_TO_SYMBOL = !fails$1(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$1(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$3(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$3(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis$2 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$4;
var toString$1 = toString$4;
var requireObjectCoercible$1 = requireObjectCoercible$5;

var charAt$2 = uncurryThis$2(''.charAt);
var charCodeAt = uncurryThis$2(''.charCodeAt);
var stringSlice$2 = uncurryThis$2(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$1(requireObjectCoercible$1($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var uncurryThis$1 = functionUncurryThis;
var toObject = toObject$2;

var floor = Math.floor;
var charAt = uncurryThis$1(''.charAt);
var replace = uncurryThis$1(''.replace);
var stringSlice$1 = uncurryThis$1(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$1(str, 0, position);
      case "'": return stringSlice$1(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$1(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var global$1 = global$F;
var call$1 = functionCall;
var anObject$1 = anObject$d;
var isCallable$1 = isCallable$j;
var classof = classofRaw$1;
var regexpExec = regexpExec$2;

var TypeError$1 = global$1.TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$1(exec)) {
    var result = call$1(exec, R, S);
    if (result !== null) anObject$1(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call$1(regexpExec, R, S);
  throw TypeError$1('RegExp#exec called on incompatible receiver');
};

var apply = functionApply;
var call = functionCall;
var uncurryThis = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var fails = fails$g;
var anObject = anObject$d;
var isCallable = isCallable$j;
var toIntegerOrInfinity = toIntegerOrInfinity$4;
var toLength = toLength$2;
var toString = toString$4;
var requireObjectCoercible = requireObjectCoercible$5;
var advanceStringIndex = advanceStringIndex$1;
var getMethod = getMethod$4;
var getSubstitution = getSubstitution$1;
var regExpExec = regexpExecAbstract;
var wellKnownSymbol = wellKnownSymbol$c;

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

const generateUrl = (shopUrl, redirectUrl, shopifyClientId, shopifyScopes, state) => `https://${shopUrl}.myshopify.com/admin/oauth/authorize?client_id=${shopifyClientId}&scope=${shopifyScopes}&redirect_uri=${redirectUrl}&state=${state}&grant_options[]=value`;

const shopifyLoginConfigFactory = (redirectUrl, shopifyClientId, shopifyScopes) => (shopUrl, state) => ({
  accessToken: null,
  loginUrl: generateUrl(shopUrl.replace('.myshopify.com', ''), redirectUrl, shopifyClientId, shopifyScopes, state),
  state,
  subDomain: shopUrl.replace('.myshopify.com', '')
});

var index$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	shopifyLoginConfigFactory: shopifyLoginConfigFactory
});

var index = /*#__PURE__*/Object.freeze({
	__proto__: null
});

const isShopInfosAlreadyInstalled = shopInfos => {
  return shopInfos.clientId !== null && shopInfos.botId !== null && shopInfos.scriptShopifyId !== null;
};

const getOneShopInfos = getOneShopInfosById => async shopInfosId => {
  const shopInfos = await getOneShopInfosById(shopInfosId);

  if (shopInfos === null) {
    return GetOneShopInfosErrors.inexistingShopInfos;
  }

  return shopInfos;
};

const getOneShopInfosByBotId = getOneShopInfosByBotId => async botId => {
  const shopInfos = await getOneShopInfosByBotId(botId);

  if (shopInfos === null) {
    return GetOneShopInfosErrors.inexistingShopInfos;
  }

  return shopInfos;
};

const createOneShopifyLoginConfig = (shopifyLoginConfigFactory, saveOneShopifyLoginConfig) => async (shopUrl, state) => {
  const loginConfig = shopifyLoginConfigFactory(shopUrl, state);
  await saveOneShopifyLoginConfig(loginConfig);
  return loginConfig.loginUrl;
};

const authenticateWithShopifyLogin = (getOneShopifyLoginConfigByState, getOneShopInfosById, getOneShopifyLoginAccessToken, getOneShopOwnerInfos, shopInfosFactory, saveOneShopInfos, registerUninstallWebhook, deleteAllShopifyLoginConfigByShopName) => async (state, authorizationCode) => {
  const shopifyLoginConfig = await getOneShopifyLoginConfigByState(state);

  if (shopifyLoginConfig === null) {
    return AuthenticateWithShopifyLoginErrors.invalidState;
  }

  if (typeof authorizationCode === 'undefined') {
    return AuthenticateWithShopifyLoginErrors.userAccessDenied;
  }

  const shopinfos = await getOneShopInfosById(shopifyLoginConfig.subDomain);

  if (shopinfos !== null && isShopInfosAlreadyInstalled(shopinfos)) {
    return AuthenticateWithShopifyLoginErrors.appAlreadyInstalled;
  }

  const shopifyLoginAccessToken = await getOneShopifyLoginAccessToken(shopifyLoginConfig, authorizationCode);

  if (shopifyLoginAccessToken === null) {
    return AuthenticateWithShopifyLoginErrors.inexistingAccessToken;
  }

  const shopOwnerInfos = await getOneShopOwnerInfos(shopifyLoginAccessToken, shopifyLoginConfig.subDomain);

  if (shopOwnerInfos === null) {
    return AuthenticateWithShopifyLoginErrors.inexistingShopOwner;
  }

  const shopifyWebhook = await registerUninstallWebhook(shopifyLoginConfig.subDomain, shopifyLoginAccessToken);
  const newShopInfos = shopInfosFactory(shopifyLoginAccessToken, shopOwnerInfos.websiteUrl, shopOwnerInfos.email, shopOwnerInfos.shopName, shopOwnerInfos.shopOwner, shopifyWebhook.id, shopOwnerInfos.phoneNumber, shopifyLoginConfig.subDomain, null, null, null);
  await saveOneShopInfos(newShopInfos);
  await deleteAllShopifyLoginConfigByShopName(shopifyLoginConfig.subDomain);
  return newShopInfos;
};

const updateOneShopInfos = (getOneShopInfosById, updateOneShopInfos) => async (shopinfoId, shopInfos) => {
  const shopInfosFind = await getOneShopInfosById(shopinfoId);

  if (shopInfosFind === null) {
    return UpdateOneShopInfosErrors.inexistingShopInfos;
  }

  await updateOneShopInfos(shopInfos);
};

const disconnectOneShopInfos = (getOneShopInfosById, removeOneShopifyActionByBotId, removeOneShopInfosById) => async shopInfosId => {
  const shopInfos = await getOneShopInfosById(shopInfosId);

  if (shopInfos === null) {
    return DisconnectOneShopInfosErrors.inexistingShopInfos;
  }

  if (shopInfos.botId !== null) {
    await removeOneShopifyActionByBotId(shopInfos.botId);
  }

  await removeOneShopInfosById(shopInfos.id);
};

const getOneShopInfosByUserId = getOneShopInfosByUserId => async userId => {
  const shopInfos = await getOneShopInfosByUserId(userId);

  if (shopInfos === null) {
    return GetOneShopInfosErrors.inexistingShopInfos;
  }

  return shopInfos;
};

export { index$7 as actionsInstalledRepositoryAxios, applicationPorts as appPorts, authenticateWithShopifyLogin, index$5 as axiosShopOwnerInfosRepository, index$8 as axiosShopify, index$4 as axiosShopifyLoginRepository, createOneShopifyLoginConfig, disconnectOneShopInfos, entitiesSchemas$1 as entitiesSchemas, getOneShopInfos, getOneShopInfosByBotId, getOneShopInfosByUserId, index$6 as postgresqlAxiosShopInfosRepository, index$2 as shopInfosModel, index$1 as shopifyLoginConfigModel, index$3 as shopifyLoginConfigRepository, updateOneShopInfos, index as userModel };
